import { HTTP as http } from "../../http";

const PREFIX = "/pedidos/";

export default {
    getPurchases: filters => {
        return http.get(PREFIX + "getListPaginate?page=" + filters.page);
    }
};
